import { Directive, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { Seo } from '../data/models/components/seo';

@Directive()
export abstract class AbstractComponent implements OnInit, OnDestroy {
  protected unsubscribeAll$?: Subject<void>;

  ngOnDestroy(): void {
    this.unsubscribeAll$?.next();
    this.unsubscribeAll$?.complete();
  }

  ngOnInit(): void {
    this.unsubscribeAll$ = new Subject();
  }

  trackBySeo<T extends { seo?: Seo }>(_index: number, item: T): string {
    return item?.seo?.title;
  }

  trackBySlug<T extends { slug?: string }>(_index: number, item: T): string {
    return item?.slug;
  }
}
